import Component from "../components/footer/CloseModalButton";

function Island() {
  return <Component />;
}

export default Island;
